/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import QuestionIcon from "@/src/assets/icons/common/toggleable/IconQuestionmark";
import { requiredValidator } from "@/src/services/validationRules";
import Group from "@/src/components/Wizard/Group";
import { useForm } from "@/src/provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import { translate } from "@/src/services/translations/translations";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { FormDataTypes } from "@/src/types/FormDataTypes";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

export default function Damage({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="damage"
                question={translate("traffic.damage.label", values)}
                options={[
                  {
                    labelText: translate("traffic.damage.options.yes.label", values),
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                  {
                    labelText: translate("traffic.damage.options.no.label", values),
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: translate("traffic.damage.options.unknown.label", values),
                    labelIcon: <QuestionIcon />,
                    labelIconActive: <QuestionIcon active />,
                    value: "unknown",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
